export default {
  common: {
    brand: "USFans Spreadsheet",
    nav: {
      home: "Home",
      shoppingGuide: "Shopping Guide",
      spreadsheet: "Spreadsheet",
      categories: "Categories",
      resources: "Resources",
      faq: "FAQ",
    },
    cta: {
      explore: "Explore Spreadsheet",
      buyNow: "Buy It Now",
      visitMain: "Visit the Main Website",
      readGuide: "Read the Complete Guide",
    },
    categoriesTitle: "Shop by Category",
    categoriesSubtitle: "Browse every product category on the main store",
    browseCategories: "Browse categories",
    jumpCategory: "Jump to a category",
    footer: {
      tagline: "An independent resource hub for the USFans Spreadsheet — guides, reviews and practical tips.",
      disclaimer: "This is an independent informational website, not affiliated with USFans or the main store. External links open in a new tab.",
      resourcesTitle: "Resources",
      categoriesTitle: "Categories",
      legalTitle: "Legal",
      rights: "All rights reserved.",
    },
    backHome: "Back to Home",
    published: "Published",
    updated: "Last updated",
    readMore: "Read the article",
    languageLabel: "Language",
  },
};